import { render, staticRenderFns } from "./UsersSettings.vue?vue&type=template&id=04d7bf9f&scoped=true&"
import script from "./UsersSettings.vue?vue&type=script&lang=js&"
export * from "./UsersSettings.vue?vue&type=script&lang=js&"
import style0 from "./UsersSettings.vue?vue&type=style&index=0&id=04d7bf9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7bf9f",
  null
  
)

export default component.exports